export default __webpack_public_path__ + "static/media/headerLocation.94d77538.svg";